/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/pow.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * Returns the value of `base` raised to the power of `exponent`.
 *
 * Note: It is still possible to overflow a double result here; in that case, null will be returned.
 *
 * @example
 * ROW base = 2.0, exponent = 2
 * | EVAL result = POW(base, exponent)
 *
 * @example
 * ROW base = 4, exponent = 0.5
 * | EVAL s = POW(base, exponent)
 */
const definition: FunctionDefinition = {
  type: 'scalar',
  name: 'pow',
  signatures: [
    {
      params: [
        {
          name: 'base',
          type: 'double',
          optional: false,
        },
        {
          name: 'exponent',
          type: 'double',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'base',
          type: 'double',
          optional: false,
        },
        {
          name: 'exponent',
          type: 'integer',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'base',
          type: 'double',
          optional: false,
        },
        {
          name: 'exponent',
          type: 'long',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'base',
          type: 'double',
          optional: false,
        },
        {
          name: 'exponent',
          type: 'unsigned_long',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'base',
          type: 'integer',
          optional: false,
        },
        {
          name: 'exponent',
          type: 'double',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'base',
          type: 'integer',
          optional: false,
        },
        {
          name: 'exponent',
          type: 'integer',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'base',
          type: 'integer',
          optional: false,
        },
        {
          name: 'exponent',
          type: 'long',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'base',
          type: 'integer',
          optional: false,
        },
        {
          name: 'exponent',
          type: 'unsigned_long',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'base',
          type: 'long',
          optional: false,
        },
        {
          name: 'exponent',
          type: 'double',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'base',
          type: 'long',
          optional: false,
        },
        {
          name: 'exponent',
          type: 'integer',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'base',
          type: 'long',
          optional: false,
        },
        {
          name: 'exponent',
          type: 'long',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'base',
          type: 'long',
          optional: false,
        },
        {
          name: 'exponent',
          type: 'unsigned_long',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'base',
          type: 'unsigned_long',
          optional: false,
        },
        {
          name: 'exponent',
          type: 'double',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'base',
          type: 'unsigned_long',
          optional: false,
        },
        {
          name: 'exponent',
          type: 'integer',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'base',
          type: 'unsigned_long',
          optional: false,
        },
        {
          name: 'exponent',
          type: 'long',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'base',
          type: 'unsigned_long',
          optional: false,
        },
        {
          name: 'exponent',
          type: 'unsigned_long',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
  ],
  preview: false,
  snapshotOnly: false,
};

export default definition;
